import styled from "styled-components";
import { Typography as TypographyMui } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

const colors = {
  red: {
    100: "#FDF3F2",
    200: "#F92513",
    300: "#db4437",
  },
  blue: {
    100: "#EDF5FF",
    200: "#4285F4",
    300: "#0B50C1",
  },
  gray: {
    0: "#FFFFFF",
    50: "#F7F7F7",
    100: "#F0F0F5",
    200: "#BDBFC6",
    300: "#777986",
    400: "#404252",
    500: "#404252",
  },
};

const setColorText = (color?: string): string => {
  switch (color) {
    case "danger":
      return colors.red[200];
    case "primary":
      return colors.gray[0];

    case "outline":
      return colors.blue[200];
    case "white":
      return "white";

    default:
      return colors.gray[300];
  }
};

const setBorderColor = (color?: string): string => {
  switch (color) {
    case "danger":
      return colors.red[200];

    case "primary":
      return colors.blue[200];

    case "outline":
      return colors.blue[200];

    default:
      return colors.gray[300];
  }
};

// const setColorHover = (color?: string): string => {
//   switch (color) {
//     case "danger":
//       return colors.red[300];
//     case "primary":
//       return colors.blue[300];
//     case "outline":
//       return colors.blue[100];
//     default:
//       return colors.gray[50];
//   }
// };
// const setBorderColorHover = (color?: string): string => {
//   switch (color) {
//     case "danger":
//       return colors.red[300];

//     case "primary":
//       return colors.blue[300];

//     case "outline":
//       return colors.blue[200];

//     default:
//       return colors.gray[300];
//   }
// };

export const ButtonStyled = styled(LoadingButton)<{
  width: string;
  color: string;
  bgColor: string;
}>`
  && {
    width: ${(props) => props.width};
    padding: 9px 16px !important;
    gap: 8px;
    height: 42px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid ${(props) => setBorderColor(props.color)};
    background-color: ${(props) => props.bgColor};
    color: ${(props) => props.color};
    &.Mui-disabled {
      background-color: #f0f0f5;
      border-color: #bdbfc6;
    }
    &.Mui-disabled > .MuiTypography-root {
      color: #bdbfc6 !important;
    }
    &.Mui-disabled > .MuiButton-startIcon {
      color: #bdbfc6 !important;
      margin: 0px !important;
    }
    & > .MuiButton-startIcon {
      color: ${(props) => setColorText(props.color)};
      margin: 0px !important;
    }
  }
`;
//&:hover {
//  background-color: ${(props) => setColorHover(props.colors)};
//  border-color: ${(props) => setBorderColorHover(props.colors)};
//}
export const Typography = styled(TypographyMui)<{
  colors?: string;
}>`
  && {
    font-style: normal;
    font-weight: 400;
    font-size: "14px";
    line-height: "20px";
    text-align: center;
    text-transform: capitalize;
    width: fit-content;
    height: fit-content;
    color: ${(props) => setColorText(props.colors)};
  }
`;
